<template>

    <div id="datePicker" class="d-flex">
        <InputData 
            label="Data início" 
            inputText="Mês/Ano início" 
            tipoData="mes" 
            formato="MM/YYYY"
            :validado="validado"
            :filtro="dataInicioLocal"
            :key="'inicio-' + dataInicioLocal"
            @emitindoMes="onDataInicioChange"
        />

        <span class="d-flex px-3 pt-2 justify-content-center align-items-center">À</span>

        <InputData
            label="Data fim" 
            inputText="Mês/Ano fim" 
            tipoData="mes" 
            formato="MM/YYYY"
            :validado="validado"
            :filtro="dataFimLocal"
            :key="'fim-' + dataFimLocal"
            @emitindoMes="onDataFimChange"
        />
    </div>

</template>

<script>
    import InputData from "@/components/formulario/data-input";

    export default({
        props: {
            dataInicio: String, 
            dataFim   : String,
            validado  : Boolean     // controla a cor dos campos (true = verde, false = vermelho)
        },
        components: {
            InputData
        },
        data() {
            return {
                dataInicioLocal: this.dataInicio,
                dataFimLocal   : this.dataFim
            }
        },
        methods: {
            onDataInicioChange(valor) {
                this.dataInicioLocal = valor;
                this.$emit('update:dataInicio', valor);
            },
            onDataFimChange(valor) {
                this.dataFimLocal = valor;
                this.$emit('update:dataFim', valor);
            }
        }
    });
</script>